import { Tooltip, Typography } from '@mui/material';
import { useStatusLabelStyles } from 'components/TeamOverview/BillingSection/styles';

export const StatusLabel = ({
  color,
  text,
  Icon = null,
  withBorder = false,
  width = '100%',
  tooltip = '',
}) => {
  const { classes } = useStatusLabelStyles({ color, withBorder, width });

  return (
    <Tooltip title={tooltip}>
      <Typography className={classes.container}>
        {Icon && <Icon className={classes.icon} />}
        {text}
      </Typography>
    </Tooltip>
  );
};
